import React, { useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";

const API_URL = "https://suadesarrollo.azurewebsites.net/api";

const AUTH = {
  username: "BasicAuth@icontec.org",
  password: "yQLzqmR7eZSuAmQZUqhY",
};

const CERTIFICACIONES = [
  {
    value: "Certificado de Reconocimiento como hospital universitario",
    label: "1. Certificado de Reconocimiento como hospital universitario",
  },
  {
    value: "Certificado como institucion amiga de la mujer (IAMI)",
    label: "2. Certificado como institución amiga de la mujer (IAMI)",
  },
  {
    value:
      "Certificado en Atención Integral a las Enfermedades Prevalentes de la Infancia -AIEPI",
    label:
      "3. Certificado en Atención Integral a las Enfermedades Prevalentes de la Infancia - AIEPI",
  },
  {
    value: "certificados de cumplimiento de las buenas prácticas",
    label: "4. Certificados de cumplimiento de las buenas prácticas",
  },
  {
    value: "certificación en Buenas Prácticas de Manufactura — BPM",
    label: "4.1 Certificación en Buenas Prácticas de Manufactura — BPM",
  },
  {
    value: "certificación en Buenas Prácticas de Laboratorio - BPL",
    label: "4.2 Certificación en Buenas Prácticas de Laboratorio - BPL",
  },
  {
    value: "certificación en Buenas Prácticas de Elaboración — BPE",
    label: "4.3 Certificación en Buenas Prácticas de Elaboración — BPE",
  },
  {
    value:
      "certificación en Buenas Prácticas de Elaboración de Radiofármacos- BPER.",
    label:
      "4.4 Certificación en Buenas Prácticas de Elaboración de Radiofármacos - BPER",
  },
  {
    value:
      "certificacion en Buenas Prácticas de Manufactura -BPM para la producción de Aire Medicinal Comprimido.",
    label:
      "4.5 Certificación en Buenas Prácticas de Manufactura - BPM para la producción de Aire Medicinal Comprimido",
  },
  {
    value:
      "cumplimiento de los requisitos para el funcionamiento del Banco de Sangre INVIMA",
    label:
      "4.6 Cumplimiento de los requisitos para el funcionamiento del Banco de Sangre INVIMA",
  },
  {
    value: "certificado en buenas practicas clinicas - BPC en investigacion",
    label:
      "4.7 Certificado en buenas prácticas clínicas - BPC en investigación",
  },
  {
    value: "5. certificación centros de excelencia",
    label: "5. Certificación centros de excelencia",
  },
  {
    value:
      "6. certificado Estandares Minimos de seguridad y salud en el trabajo expedido por el Ministerio de Trabajo",
    label:
      "6. Certificado Estándares Mínimos de Seguridad y Salud en el Trabajo expedido por el Ministerio de Trabajo",
  },
];

function CreaCertificaciones({ idSolicitud, onCreated }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [certificacion, setCertificacion] = useState("");

  const [archivos, setArchivos] = useState([]);

  const [isLoading, setLoading] = useState(false);

  const [error, setError] = useState("");

  /**
   * Abrir modal
   */
  const abrirModal = () => {
    setError("");
    setModalIsOpen(true);
  };

  /**
   * Cerrar modal
   */
  const cerrarModal = () => {
    if (isLoading) return;

    setModalIsOpen(false);
    setCertificacion("");
    setArchivos([]);
    setError("");
  };

  /**
   * Seleccionar archivo
   */
  const handleArchivo = (event) => {
    const archivosSeleccionados = Array.from(event.target.files || []);

    setArchivos(archivosSeleccionados);
    setError("");
  };

  /**
   * Guardar certificación
   */
  const insertarArchivos = async (event) => {
    event.preventDefault();

    setError("");

    if (!idSolicitud) {
      setError("No se encontró el identificador de la solicitud.");
      return;
    }

    if (!certificacion) {
      setError("Debe seleccionar una certificación.");
      return;
    }

    if (archivos.length === 0) {
      setError("Debe seleccionar al menos un archivo.");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();

      archivos.forEach((archivo) => {
        formData.append("files", archivo);
      });

      const response = await axios.post(
        `${API_URL}/CargaCertificaciones/${idSolicitud}/${certificacion}`,
        formData,
        {
          auth: AUTH,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("Certificación creada:", response.data);

      alert("Certificación cargada correctamente.");

      /**
       * Actualizar tabla del padre
       */
      if (typeof onCreated === "function") {
        await onCreated();
      }

      /**
       * Cerrar modal después de actualizar
       */
      cerrarModal();
    } catch (error) {
      console.error("Error al cargar certificación:", error);

      let mensaje = "No fue posible cargar la certificación.";

      if (error.response?.data?.message) {
        mensaje = error.response.data.message;
      } else if (typeof error.response?.data === "string") {
        mensaje = error.response.data;
      }

      setError(mensaje);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button
        type="button"
        className="btn btn-primary"
        onClick={abrirModal}
        disabled={isLoading}
      >
        Nueva Certificación
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={cerrarModal}
        contentLabel="Crear Certificación"
        ariaHideApp={false}
        shouldCloseOnOverlayClick={!isLoading}
        shouldCloseOnEsc={!isLoading}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "900px",
            maxHeight: "90vh",
            padding: "0",
            borderRadius: "8px",
            overflow: "auto",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.65)",
            zIndex: 1050,
          },
        }}
      >
        <div className="card shadow mb-0">
          {/* HEADER */}
          <div className="card-header py-3 d-flex justify-content-between align-items-center">
            <h6 className="m-0 font-weight-bold text-primary">
              Nueva Certificación
            </h6>

            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={cerrarModal}
              disabled={isLoading}
            >
              ×
            </button>
          </div>

          {/* BODY */}
          <div className="card-body">
            <form onSubmit={insertarArchivos}>
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              {/* CERTIFICACIÓN */}
              <div className="form-group">
                <label htmlFor="certificacion" className="font-weight-bold">
                  Certificación
                </label>

                <select
                  id="certificacion"
                  className="form-control"
                  value={certificacion}
                  onChange={(e) => setCertificacion(e.target.value)}
                  disabled={isLoading}
                >
                  <option value="">Seleccione la certificación</option>

                  {CERTIFICACIONES.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* ARCHIVOS */}
              <div className="form-group">
                <label
                  htmlFor="archivoCertificacion"
                  className="font-weight-bold"
                >
                  Documento soporte
                </label>

                <input
                  id="archivoCertificacion"
                  type="file"
                  name="files"
                  className="form-control-file"
                  multiple
                  onChange={handleArchivo}
                  disabled={isLoading}
                />

                {archivos.length > 0 && (
                  <div className="mt-3">
                    <div className="alert alert-info mb-2">
                      <strong>{archivos.length}</strong> archivo
                      {archivos.length !== 1 ? "s" : ""} seleccionado
                      {archivos.length !== 1 ? "s" : ""}.
                    </div>

                    <ul className="list-group">
                      {archivos.map((archivo, index) => (
                        <li
                          key={`${archivo.name}-${index}`}
                          className="list-group-item d-flex justify-content-between"
                        >
                          <span>{archivo.name}</span>

                          <small className="text-muted">
                            {(archivo.size / 1024 / 1024).toFixed(2)} MB
                          </small>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              <hr />

              {/* ACCIONES */}
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={cerrarModal}
                  disabled={isLoading}
                >
                  Cancelar
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={
                    isLoading || !certificacion || archivos.length === 0
                  }
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Guardando...
                    </>
                  ) : (
                    "Guardar Certificación"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaCertificaciones;
